import { createThemeCompiler } from '../../../utils';

export const numberboxThemeCompiler = createThemeCompiler(({ borderRadius, palette }) => ({
    numberbox: {
        colors: {
            default: {
                iconBackgroundColor: palette.white,
                iconColor: palette.neutralPrimary
            },
            active: {
                iconBackgroundColor: palette.themeLightAlt,
                iconColor: palette.themePrimary
            },
            disabled: {
                iconBackgroundColor: palette.neutralQuaternary,
                iconColor: palette.neutralSecondaryAlt
            },
            error: {
                iconBackgroundColor: palette.redPale,
                iconColor: palette.red
            },
            hovered: {
                iconBackgroundColor: palette.themeLightAlt,
                iconColor: palette.themePrimary
            }
        },
        composites: {
            decrementerBorderRadius: `0 0 ${borderRadius.curvedSmall} 0`,
            incrementorBorderRadius: `0 ${borderRadius.curvedSmall} 0 0`
        }
    }
}));
